import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

export default function Header() {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <header>
      <h1>Frontpage</h1>
      <div className="user-info">
        <span>{user?.username}</span>
        <Link to="/classifiers">classifiers</Link>
        <Link to="/settings">settings</Link>
        <button type="button" onClick={handleLogout}>
          logout
        </button>
      </div>
    </header>
  );
}
